import { ClassificationType } from 'sigma-mappings';

const diagnosticsClassificationsDictionary = vm => ([
  {
    id: ClassificationType.CRITICAL,
    name: vm.$t('enums.engineering.diagnostics-history.critical'),
  },
  {
    id: ClassificationType.OBSERVATION,
    name: vm.$t('enums.engineering.diagnostics-history.observation'),
  },
  {
    id: ClassificationType.ORDINARY,
    name: vm.$t('enums.engineering.diagnostics-history.ordinary'),
  },
  {
    id: ClassificationType.URGENT,
    name: vm.$t('enums.engineering.diagnostics-history.urgent'),
  },
]);

export default diagnosticsClassificationsDictionary;
